import { findIndex, find } from 'lodash';
import { useMemo } from 'react';
import { useMainMenu } from './use-main-menu';
import { useEntity } from './use-entity';
var emptyResult = {
  items: [],
  hasNext: false,
  hasPrev: false
};
export var useMenuPosition = function useMenuPosition(menu) {
  var mainMenu = useMainMenu();
  var menuToUse = menu || mainMenu || {
    items: []
  };
  var _a = menuToUse.items,
      items = _a === void 0 ? [] : _a;
  var page = useEntity();

  if (!(items && items.length && page)) {
    return emptyResult;
  }

  return useMemo(function () {
    var selectedIndex = findIndex(items, function (item) {
      return item.path === page.path;
    });
    var current = find(items, function (item) {
      return item.path === page.path;
    });
    var next = selectedIndex !== -1 ? selectedIndex < items.length - 1 ? items[selectedIndex + 1] : null : null;
    var prev = selectedIndex > 0 ? items[selectedIndex - 1] : null;
    var hasNext = !!next;
    var hasPrev = !!prev;
    var ret = {
      items: items,
      current: current,
      next: next,
      prev: prev,
      hasNext: hasNext,
      hasPrev: hasPrev
    };

    if (process.env.DEBUG_NAVIGATION_POSITION === "true") {
      console.log("USE NAVIGATION POSITION", ret);
    }

    return ret;
  }, [page, items]);
};